export const HANDOVER_CHECKLIST = "HANDOVER_CHECKLIST";
export const GATE_INFO = "GATE_INFO";
export const GATE_DETAIL = "GATE_DETAIL";

